<template>
  <el-container style="height: 100vh;overflow:auto">
    <el-aside width="250px" style="text-align: center;">
      <aside-page/>
    </el-aside>
    <el-container>
      <el-header style="background-color: white">
        <header-page/>
      </el-header>
      <el-main class="background">
        <div style="height: 14px;background-color: white;width: 100%;border-radius: 10px 10px 0 0"></div>
        <main-page/>
        <div style="height: 14px;background-color: white;width: 100%;border-radius: 0 0 10px 10px"></div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>

import MainPage from './components/main/Main.vue'
import HeaderPage from './components/header/Header.vue'
import AsidePage from './components/aside/Aside.vue'
import {selectDictByType} from '/src/api/contacts/dict'
import {selectDeptTree} from '@/api/org';
import {selectDeptTree as selectDeptTreePrincipal} from '/src/api/contacts/dept'
export default {
  name: "home",
  components: { MainPage,HeaderPage,AsidePage },
  data() {
    return {}
  },
  methods:{
    /**
     * 查询全部部门 ---- 树解构
     */
    selectDeptTree(){
      selectDeptTree().then(val=>{
        if (val.status == 200){
          localStorage.removeItem("deptTree");
          localStorage.setItem("deptTree",JSON.stringify(val.data));
        }
      })
    },
    /**
     * 查询全部部门（含部门负责人） ---- 树解构
     */
    selectDeptTreePrincipal(){
      selectDeptTreePrincipal().then(val=>{
        if (val.status == 200){
          localStorage.removeItem("deptTreePrincipal");
          localStorage.setItem("deptTreePrincipal",JSON.stringify(val.data));
        }
      })
    },
    /**
     * 查询学员类型：中招、少儿、高考、贝体
     */
    selectFlagType(){
      selectDictByType("flagType").then(val=>{
        if (val.status == 200){
          let dict = JSON.parse(localStorage.getItem("dict") || "{}");
          dict.flagList = val.data;
          localStorage.setItem("dict",JSON.stringify(dict));
        }
      })
    },
  },
  created() {
    //查询全部部门 ---- 树解构
    this.selectDeptTree();
    //缓解服务器压力延迟执行
    setTimeout(() => {
      this.selectDeptTreePrincipal();
    }, 3000);
    //查询学员类型：中招、少儿、高考、贝体
    this.selectFlagType();
  }
}
</script>

<style>
.background{
  background-color:#FAFAFA
}
</style>
<style scoped>

</style>